'use client';
import { RefObject, useEffect } from 'react';

const useEscapeHandlers = (
  getter: boolean,
  setter: (val: boolean) => void,
  contentRef: RefObject<any>,
  focusRef?: RefObject<any>
) => {
  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      if (getter) {
        setter(false);
      }
    }
  };

  const handleClickOutside = (e: PointerEvent) => {
    if (!contentRef.current) {
      return;
    }

    if (!contentRef.current.contains(e.target as HTMLElement)) {
      setter(false);
    }
  };

  // Register 'click outside' listener
  useEffect(() => {
    if (getter) {
      window.addEventListener('pointerdown', handleClickOutside);
    }
    return () => window.removeEventListener('pointerdown', handleClickOutside);
  }, [getter]);

  // Register 'escape' to close listener
  useEffect(() => {
    document.removeEventListener('keydown', handleKeyPress);

    if (getter && focusRef?.current) {
      focusRef.current.focus({ preventScroll: true });
      document.addEventListener('keydown', handleKeyPress);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [getter]);

  return null;
};

export default useEscapeHandlers;
